import { FormattedMessage } from 'react-intl';
import { Outlet, generatePath } from 'react-router-dom';
import styled from 'styled-components';

import { catchAll } from '@sorare/routing';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import {
  MLB_PLAY_LINEUPS_EVENTTYPE,
  MLB_PLAY_LINEUPS_EVENTTYPE_FIXTURE,
} from '@sorare/core/src/constants/__generated__/routes';
import { glossary } from '@sorare/core/src/lib/glossary';

const CenterTabBar = styled.div`
  display: flex;
  justify-content: center;
  margin-top: var(--double-unit);

  > :first-child {
    width: min-content;
  }
`;

const Layout = () => {
  return (
    <>
      <CenterTabBar>
        <TabBar variant="primary">
          <Tab
            matches={[
              catchAll(
                generatePath(MLB_PLAY_LINEUPS_EVENTTYPE, {
                  eventType: So5FixtureEvent.DAILY.toLowerCase(),
                })
              ),
            ]}
            to={generatePath(MLB_PLAY_LINEUPS_EVENTTYPE_FIXTURE, {
              eventType: So5FixtureEvent.DAILY.toLowerCase(),
              fixture: 'ongoing',
            })}
          >
            <FormattedMessage {...glossary.daily} />
          </Tab>
          <Tab
            matches={[
              catchAll(
                generatePath(MLB_PLAY_LINEUPS_EVENTTYPE, {
                  eventType: So5FixtureEvent.CLASSIC.toLowerCase(),
                })
              ),
            ]}
            to={generatePath(MLB_PLAY_LINEUPS_EVENTTYPE_FIXTURE, {
              eventType: So5FixtureEvent.CLASSIC.toLowerCase(),
              fixture: 'ongoing',
            })}
          >
            <FormattedMessage {...glossary.biweekly} />
          </Tab>
        </TabBar>
      </CenterTabBar>
      <Outlet />
    </>
  );
};

export default Layout;
